export default __webpack_public_path__ + "static/media/RotacionaKomora.e23051f7.png";